import User from '@/utils/user';
import { TASK_COLOR } from './components/plan-gantt/constants';
import { dateFnsFormat } from '@/helpers/dateFns';

const user = new User();

export const planNameByRole = () => {
  if (user?.isOperator) return 'Региональный план';
  if (user?.isDepartment) return 'Муниципальный план';
  return 'План моих мероприятий';
};

export const planInstruction = () => {
  const INSTUCTION = {
    id: 338,
    name: 'План мероприятий',
  };
  if (user?.isOrganization) return INSTUCTION;
  return null;
};

export const getAnnounDate = (start, end) => {
  if (start === end) return dateFnsFormat.readableDateWithShortYear(start);
  return `${dateFnsFormat.readableDateWithShortYear(start)}-${dateFnsFormat.readableDateWithShortYear(end)}`;
};

export const prepareAnnounsToGanttItems = (announs) => (announs || []).map((item) => {
  const { id, name, event, start_at, end_at } = item; // model if ...-sorted
  const color = event ? TASK_COLOR.withEvent : TASK_COLOR.withoutEvent;

  return {
    id,
    title: name,
    color,
    startAt: start_at,
    endAt: end_at,
  };
});
